import { ValueObject, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class ProcessTypeLookup extends ValueObject {
    public processTypeID: number | null = null;

    public process: string | null = null;

    public selectedInd: boolean = false;
}